var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AiDashboard',{attrs:{"client":_vm.data._id,"aiEnabled":_vm.data.aiEnabled,"url":'/v2/ai/get-all-features',"editable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }